export default __webpack_public_path__ + "static/RobertEarle-607e40b03ba4479fe0f90b49f1cbc9c3.jpg";